import { render, staticRenderFns } from "./screenshots.vue?vue&type=template&id=49230dfd&"
import script from "./screenshots.vue?vue&type=script&lang=js&"
export * from "./screenshots.vue?vue&type=script&lang=js&"
import style0 from "./screenshots.vue?vue&type=style&index=0&id=49230dfd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports